module.exports = __webpack_public_path__ + "static/media/Lockheedlogo.0230c597.png";